import React from "react";
import "./Menu.css";
const Menu = () => {
  return (
    <>
      <div className="menu_cont">
        <div className="title_name" id="Menu">
          Menu
        </div>

        <div className="container_mi">
          <div className="english_item">
            <h2>चिकन - मेन्यू</h2>
            <h5>चिकन बिर्याणी - रु.150</h5>
            <h5>चिकन लॉलीपॉप - रु.180 </h5>
            <h5>चिकन चिल्ली - रु.200</h5>
            <h5>चिकन मसाला - रु. 180</h5>
            <h5>चिकन उख्खर- रु.140</h5>
            <h5>चिकन फ्राय - रु. 140</h5>
            <h5>चिकन हंडी - रु. 250/450</h5>
            <h5>स्पे.चिकन थाळी - रु.250</h5>
            <h5>चिकन मालवणी- रु.350/600</h5>
            <h5>चिकन दालचा राईस- रु.150</h5>
          </div>
          <div className="marathi_item">
            <h2>मटन मेन्यू</h2>
            <h5>मटन बिर्याणी - रु.250</h5>
            <h5>मटन मसाला- रु.230</h5>
            <h5>मटन उख्खर- रु. 230</h5>
            <h5>मटण हंडी - रु.350/600</h5>
            <h5>स्पेशल मटन थाळी- रु.350</h5>
            <h5>मटन मालवणी - रु.400</h5>
            <h5>मटन दालचा राईस - रु. 250</h5>
          </div>
        </div>
        <div className="container_mi">
          <div className="english_item">
            <h2>अंडा मेन्यू</h2>
            <h5>अंडा बिर्याणी - रु.150</h5>
            <h5>अंडा करी - रु.130</h5>
            <h5>अंडा मसाला - रु. 130</h5>
            <h5>अंडा फ्राय - रु. 40</h5>
            <h5>अंडा थाळी - रु. 170</h5>
            <h5>बॉईल अंडा - रु.30</h5>
          </div>
          <div className="marathi_item">
            <h2>चायनीज मेन्यू </h2>
            <h5> चिकन शेजवान राईस - रु.150</h5>
            <h5>चिकन शेजवान नूडल्स - रु.150</h5>
          </div>
        </div>
        <div className="container_mi">
          <div className="marathi_item">
            <h2>पनीर मेन्यू</h2>
            <h5>पनीर बिर्याणी - रु.150</h5>
            <h5>पनीर मसाला - रु.150</h5>
            <h5>काजू पनीर मसाला - रु.170</h5>
            <h5>काजू मसाला रु. 170</h5>
            <h5>मसाला पापड- - रु. 20</h5>
            <h5>जिरा राईस- - रु. 50/70</h5>
          </div>
        </div>
      </div>
    </>
  );
};

export default Menu;